module.exports = __webpack_public_path__ + "img/9788925535623.eda1c057.jpg";